import { Injectable } from "@angular/core";
import { GenericService } from "../../../core/commons/generic.service";
import { Topic } from "../../domain/topic";
import { AuthService } from "../../../core/security/auth.service";
import { QueryOptions } from "../../../core/commons/query.options";
import { RequestMethod, URLSearchParams } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { PaginationPage } from "app/core/commons/pagination-page";

@Injectable()
export class TopicService extends GenericService<Topic> {
  private resourcePath: string = "/topic";

  constructor(public authService: AuthService) {
    super(authService);
  }

  protected valueToEntity(value: Object): Topic {
    return new Topic(value);
  }

  protected getResourcePath(): string {
    return this.resourcePath;
  }

  public getDefaultQueryOptions(): QueryOptions {
    return new QueryOptions();
  }

  public findByValue(value: string): Observable<Topic[]> {
    let req = this.buildRequest(RequestMethod.Get);
    req.params = new URLSearchParams();
    req.params.set("value", value);
    return this.authService
      .authRequest(this.baseUrl + this.resourcePath + "/find", req)
      .map(res => res.json().map(t => this.valueToEntity(t)));
  }

  public pagedSearch(
    name: string,
    queryOptions: QueryOptions = this.getDefaultQueryOptions()
  ): Observable<PaginationPage<Topic>> {
    const ro = queryOptions.getQueryRequestOptions().merge({
      url: this.baseUrl + this.getResourcePath() + "/search"
    });
    if (name) {
      ro.params.append("name", name);
    }
    return this.doRequest(ro)
      .map(res => res.json())
      .concatMap(json =>
        Observable.from(json.content)
          .concatMap(value => this.mapValueToEntityQuery(value))
          .toArray()
          .map(content => new PaginationPage({ ...json, content: content }))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/forum/topic.service.ts